import AnalytesTable from './AnalytesTable';
import AnalytesColumns from './AnalytesColumns';
import AnalytesRows from './AnalytesRows';

export default AnalytesTable;
export {
  AnalytesColumns,
  AnalytesRows
};
